import { Box, Paper } from '@mui/material'
import React from 'react'
import { addActiveClass, customStyles, spaceBetween } from '../../../styles'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { RegularText, SmallText } from '../../helpers';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
export const OnGoingService = () => {
  const { activeOrders } = useSelector(state => state.order)
  
  const navigate = useNavigate()
  const handleNavigate = () => {
     navigate('/dashboard/order')
  }
  return (
    <Paper sx={ {...spaceBetween, backgroundColor: customStyles.colors.secondary, height: 60, padding: '0 15px', borderRadius: 2, color: customStyles.colors.backgroundColor, margin: '10px 0' } }>
      <Box sx={ spaceBetween }>
        <LocalShippingOutlinedIcon sx={{ marginRight: 3 }}/>
        <RegularText text={`Tienes ${activeOrders?.length === 1 ? 'un' : activeOrders.length} ${ activeOrders?.length === 1 ? 'servicio' : 'servicios' } en curso`}/>
      </Box>
      <Box  sx={{ cursor: 'pointer', ...addActiveClass, ...spaceBetween }}onClick={handleNavigate}>
        <SmallText text="Ver detalles" underline />
        <ChevronRightIcon />
      </Box>
    </Paper>
  )
}
